import cn from 'classnames';
import { FC, ReactNode } from 'react';
import { TYPOGRAPHY_VARIATIONS } from 'src/utils/constants';
import styles from './styles.module.scss';

type TypographyVariants =
  | 'subtitle1'
  | 'subtitle2'
  | 'subtitle3'
  | 'inherit'
  | 'caption'
  | 'body1'
  | 'body2'
  | 'body3'
  | 'body4'
  | 'body5'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6';

type TypographyColor =
  | 'textSecondary'
  | 'textPrimary'
  | 'white'
  | 'textThird'
  | 'textLight'
  | 'secondary'
  | 'textDark'
  | 'primary'
  | 'initial'
  | 'inherit'
  | 'third'
  | 'error'
  | 'valid'
  | 'gray-300';

type TypographyComponents = 'h1' | 'h4' | 'h5' | 'h6' | 'div' | 'p' | 'span';

type Props = {
  isCapitalize?: boolean;
  isUppercase?: boolean;
  component?: TypographyComponents | string;
  variant?: TypographyVariants | string;
  className?: string;
  color?: TypographyColor | string;
  children: ReactNode | string | number;
  style?: { [key: string]: string };
  fontWeight?: string;
  uppercase?: boolean | undefined;
  noWrap?: boolean | undefined;
  display?: string;
};
export const Typography: FC<Props> = ({
  isCapitalize,
  component,
  isUppercase,
  className,
  children,
  variant,
  color = 'inherit',
  style,
}) => {
  const CustomTypography = component || (variant && TYPOGRAPHY_VARIATIONS[variant]) || 'span';

  return (
    <CustomTypography
      style={style}
      className={cn(
        styles.typography,
        {
          [styles[`typography_variant_${variant}`]]: variant,
          [styles[`typography_color_${color}`]]: color,
          [styles.typography_uppercase]: isUppercase,
          [styles.typography_capitalize]: isCapitalize,
        },
        className
      )}
    >
      {children}
    </CustomTypography>
  );
};
